module.exports = __webpack_public_path__ + "static/media/maze-generator.9b3cf548.gif";